import {
  SADMIN_ADMIN_CREATE_REQUEST,
  SADMIN_ADMIN_CREATE_SUCCESS,
  SADMIN_ADMIN_CREATE_FAIL,
  SADMIN_ADMIN_CREATE_RESET,
  SADMIN_ADMIN_LIST_REQUEST,
  SADMIN_ADMIN_LIST_SUCCESS,
  SADMIN_ADMIN_LIST_FAIL,
  SADMIN_ADMIN_VIEW_REQUEST,
  SADMIN_ADMIN_VIEW_SUCCESS,
  SADMIN_ADMIN_VIEW_FAIL,
  SADMIN_ADMIN_PERMISSIONS_REQUEST,
  SADMIN_ADMIN_PERMISSIONS_SUCCESS,
  SADMIN_ADMIN_PERMISSIONS_FAIL,
  SADMIN_LOGS_LIST_REQUEST,
  SADMIN_LOGS_LIST_SUCCESS,
  SADMIN_LOGS_LIST_FAIL,
} from "./adminsTypes";

export const adminReducer = (state = { admins: [] }, action) => {
  switch (action.type) {
    // ADMIN LIST
    case SADMIN_ADMIN_LIST_REQUEST:
      return { ...state, loading: true };

    case SADMIN_ADMIN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        admins: action.payload,
      };
    case SADMIN_ADMIN_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    // CREATE ADMIN
    case SADMIN_ADMIN_CREATE_REQUEST:
      return { ...state, loading: true };

    case SADMIN_ADMIN_CREATE_SUCCESS:
      return { ...state, loading: false, success: true };

    case SADMIN_ADMIN_CREATE_RESET:
      return { ...state, loading: false, success: false };

    case SADMIN_ADMIN_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // VIEW admin
    case SADMIN_ADMIN_VIEW_REQUEST:
      return { ...state, loading: true };

    case SADMIN_ADMIN_VIEW_SUCCESS:
      return { ...state, admin: action.payload, loading: false };

    case SADMIN_ADMIN_VIEW_FAIL:
      return { ...state, loading: false, error: action.payload };

    // PERMISSIONS ADMIN
    case SADMIN_ADMIN_PERMISSIONS_REQUEST:
      return { ...state, loading: true };

    case SADMIN_ADMIN_PERMISSIONS_SUCCESS:
      return { ...state, loading: false, admin: action.payload };

    case SADMIN_ADMIN_PERMISSIONS_FAIL:
      return { ...state, loading: false, error: action.payload };

    // LOGS LIST
    case SADMIN_LOGS_LIST_REQUEST:
      return { ...state, loading: true };

    case SADMIN_LOGS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        logs: action.payload.logs,
        total: action.payload.total,
      };
    case SADMIN_LOGS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
